/**
 * Release Manager API - Version management endpoints
 */
import { apiClient } from './client';

export const RELEASE_MANAGER_API_BASE = '/api/v1/releasemanagers';

export interface ReleaseVersion {
  createdAt: string;
  deprecated: boolean;
  name: string;
  version: string;
}

export interface ReleaseVersionsResponse {
  items: ReleaseVersion[];
  total: number;
}

export type VersionSubType = 'cluster' | 'metadata';

/**
 * Get versions URL for a specific subtype
 */
export function getVersionsUrl(subType: VersionSubType): string {
  return `${RELEASE_MANAGER_API_BASE}/versions?product=engine&subType=${subType}`;
}

/**
 * Query service versions URL
 */
export const QUERY_SERVICE_VERSIONS_URL = getVersionsUrl('cluster');

/**
 * Metadata service versions URL
 */
export const METADATA_SERVICE_VERSIONS_URL = getVersionsUrl('metadata');

/**
 * Release Manager API methods
 */
/**
 * Agent sync API URL - triggers immediate release version refresh
 */
export const AGENT_SYNC_URL = '/api/v1/agent/sync';

export const releaseManagerApi = {
  /**
   * Get versions for a specific subtype
   */
  getVersions: (subType: VersionSubType): Promise<ReleaseVersionsResponse> => {
    return apiClient.get(`${RELEASE_MANAGER_API_BASE}/versions`, {
      params: {
        product: 'engine',
        subType,
      },
    });
  },

  /**
   * Get query service versions
   */
  getQueryServiceVersions: (): Promise<ReleaseVersionsResponse> => {
    return releaseManagerApi.getVersions('cluster');
  },

  /**
   * Get metadata service versions
   */
  getMetadataServiceVersions: (): Promise<ReleaseVersionsResponse> => {
    return releaseManagerApi.getVersions('metadata');
  },
};
